module.exports = __webpack_public_path__ + "static/mokai-eb56428a79593281ce4d817c74536b96.svg";